<div class="modal-card">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-left">
      <div class="header-icon-box">
        <mat-icon>manage_accounts</mat-icon>
      </div>
      <div>
        <h3 class="modal-title">Admin Profile</h3>
        <p class="modal-subtitle">Update your personal account information</p>
      </div>
    </div>
    <button
      mat-icon-button
      (click)="dialogRef.close()"
      class="close-btn"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body" mat-dialog-content>
    <form [formGroup]="profileForm">
      <!-- Avatar Section -->
      <div class="avatar-wrapper">
        <input
          type="file"
          #fileInput
          style="display: none"
          (change)="uploadFile($event, fileInput)"
          accept="image/*"
        />

        <div
          class="avatar-ring"
          (click)="fileInput.click()"
          matTooltip="Click to change profile picture"
        >
          <img
            *ngIf="!profileImageUrl"
            src="/assets/images/profile/user-1.jpg"
            alt="Profile Avatar"
            class="avatar-photo"
          />
          <img
            *ngIf="profileImageUrl"
            [src]="profileImageUrl"
            alt="Profile Avatar"
            class="avatar-photo"
          />
          <div class="camera-badge">
            <mat-icon>photo_camera</mat-icon>
          </div>
        </div>
        <span class="avatar-caption">Click avatar to upload photo</span>
      </div>

      <!-- Fields Grid (2 Columns for Names, 1 Column for Email) -->
      <div class="fields-grid">
        <div class="form-field-item">
          <label class="input-label">First Name</label>
          <mat-form-field
            appearance="outline"
            class="w-100"
            subscriptSizing="dynamic"
          >
            <input
              matInput
              formControlName="firstName"
              placeholder="First Name"
            />
          </mat-form-field>
          <control-messages
            [control]="profileForm.controls['firstName']"
            [inputElmControl]="inputControls.message.required"
          >
          </control-messages>
        </div>

        <div class="form-field-item">
          <label class="input-label">Last Name</label>
          <mat-form-field
            appearance="outline"
            class="w-100"
            subscriptSizing="dynamic"
          >
            <input
              matInput
              formControlName="lastName"
              placeholder="Last Name"
            />
          </mat-form-field>
          <control-messages
            [control]="profileForm.controls['lastName']"
            [inputElmControl]="inputControls.message.required"
          >
          </control-messages>
        </div>

        <div class="form-field-item full-span">
          <label class="input-label">Email Address (Read-only)</label>
          <mat-form-field
            appearance="outline"
            class="w-100"
            subscriptSizing="dynamic"
          >
            <mat-icon matPrefix>email</mat-icon>
            <input matInput formControlName="email" readonly />
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer Actions -->
  <div class="modal-footer" mat-dialog-actions>
    <button mat-stroked-button (click)="dialogRef.close()" class="btn-cancel">
      Cancel
    </button>
    <button mat-flat-button (click)="save()" class="btn-submit">
      <mat-icon>save</mat-icon>
      Save Changes
    </button>
  </div>
</div>
